import { GameProject } from '../types';

export function GameCard(game: GameProject): string {
  const techChips = game.techStack.map(tech => /*html*/`
    <span style="font-size: 0.72rem; padding: 0.2rem 0.5rem; border-radius: 4px; background: rgba(6, 214, 160, 0.12); color: #34d399; border: 1px solid rgba(6, 214, 160, 0.25);">
      ${tech}
    </span>
  `).join('');

  return /*html*/`
    <div class="glass-panel" style="display: flex; flex-direction: column; overflow: hidden; height: 100%; border-top: 3px solid #06d6a0;">
      
      <!-- Media Header -->
      <div style="position: relative; height: 190px; overflow: hidden; background: #000;">
        <img 
          src="${game.image}" 
          alt="${game.title}" 
          style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease;"
          onmouseover="this.style.transform='scale(1.04)'"
          onmouseout="this.style.transform='scale(1.0)'"
        />
        <div style="position: absolute; top: 0.85rem; right: 0.85rem;">
          <span class="badge badge-green">${game.status}</span>
        </div>
        <div style="position: absolute; bottom: 0.85rem; left: 0.85rem;">
          <span class="badge badge-cyan">${game.category}</span>
        </div>
      </div>

      <!-- Content -->
      <div style="padding: 1.5rem; display: flex; flex-direction: column; flex-grow: 1; justify-content: space-between;">
        <div>
          <h3 style="font-size: 1.25rem; font-weight: 700; margin-bottom: 0.6rem; color: #fff;">
            ${game.title}
          </h3>
          <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6; margin-bottom: 1.25rem;">
            ${game.description}
          </p>

          <!-- Tech Stack -->
          <div style="display: flex; flex-wrap: wrap; gap: 0.4rem; margin-bottom: 1.5rem;">
            ${techChips}
          </div>
        </div>

        <!-- Action Links -->
        <div style="display: flex; gap: 0.6rem; flex-wrap: wrap; border-top: 1px solid rgba(255,255,255,0.06); padding-top: 1rem;">
          ${game.githubUrl ? /*html*/`
            <a href="${game.githubUrl}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="github"></sl-icon>
              <span>GitHub Org</span>
            </a>
          ` : ''}

          ${game.steamUrl ? /*html*/`
            <a href="${game.steamUrl}" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #1b2838 0%, #2a475e 100%); padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="steam"></sl-icon>
              <span>Steam Page</span>
            </a>
          ` : ''}

          ${game.appStoreUrl ? /*html*/`
            <a href="${game.appStoreUrl}" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #007aff 0%, #00c6ff 100%); padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="apple"></sl-icon>
              <span>App Store</span>
            </a>
          ` : ''}
        </div>

      </div>

    </div>
  `;
}
